export default __webpack_public_path__ + "static/media/50.1d4f70e5.png";